import DocutaxClient from './DocutaxClient';
import DocutaxSubmissionSearchResult from './DocutaxSubmissionSearchResult';
import DocutaxRequestSearchResult from './DocutaxRequestSearchResult';

export default class DocutaxClientProfile {
  /**
   * @type {DocutaxClient}
   */
  client;

  /**
   * @type {DocutaxSubmissionSearchResult[]}
   */
  submissions = [];

  /**
   * @type {DocutaxRequestSearchResult[]}
   */
  requests = [];

  constructor(opts = null) {
    if (opts != null) {
      if (opts.client != null) {
        this.client = new DocutaxClient(opts.client);
      }
      if (opts.submissions != null) {
        this.submissions = opts.submissions.map(s => new DocutaxSubmissionSearchResult(s));
      }
      if (opts.requests != null) {
        this.requests = opts.requests.map(r => new DocutaxRequestSearchResult(r));
      }
    }
  }
}
